import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import '../style-modal.scss';
import { t } from 'i18next';

function NewInquiryComplete(props) {
    const pageCode = "Support";
    const [item, setItem] = useState({});
    const [error, setError] = useState('')

    useEffect(() => {
        console.log("Effect running only on mount phase");
        onShow()
    }, []);

    useEffect(() => {
        console.log("Effect running when item changed");
    }, [item]);

    const onShow = async () => {
        setError('')
        onLoadData()
    }

    const onNext = async () => {
        props.onNext(item)
    }
    const onLoadData = async () => {
        console.log('onLoadData')
        setItem({
            ...props.item
        })
    }

    return (
        <>
            <Modal {...props} aria-labelledby={t(`${pageCode}.YourInquiryIsComplete`)}
                backdrop="static"
                keyboard={false}
                centered={true}
                size="sm"
                onShow={onShow}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="text-center">{t(`${pageCode}.YourInquiryIsComplete`)}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-newcontact-complete">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div>{t(`${pageCode}.ThankYouForContactingUs`)}</div>
                            <div>{t(`${pageCode}.WeWillGetBackToYouWithAnAnswerShortly`)}</div>
                            {!props.isGuest && (
                                <div>
                                    {t(`${pageCode}.InTheMeanTime,YouCanTrackYourInquiry`)}
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ border: 'none' }}>
                    <div className="dlg-btns text-center" style={{ margin: 'auto' }}>
                        <Button variant="outline-secondary" className="btn-outline-secondary mr-2" onClick={props.onHide}> {t(`${pageCode}.Close`)} </Button>
                        {!props.isGuest && (
                            <Button variant="default fs-1" onClick={onNext}>{t(`${pageCode}.GotoMyInquiry`)}</Button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NewInquiryComplete;